,
<script lang="ts">
import { defineBlock } from "@bagelink/blox"
import { $, defineSchema } from "@bagelink/vue"
const schema = defineSchema({
  height: $.number("Height (rem)", {
    default: "2",
    helpText:
      "Use a positive value to add vertical space or a negative value to pull the following block upward.",
  }),
  whiteBackground: $.checkbox("White background", { default: false }),
});
export const Spacer = defineBlock({
  name: "Spacer",
  label: "Spacer",
  icon: "height",
  thumbnail: "/block-thumbs/Spacer.svg",
  category: "General",
  order: 120,
  schema,
})
</script>
<script setup lang="ts">
import { computed } from "vue";




;

const props = defineProps<{
  height?: string;
  whiteBackground?: boolean;
}>();

const spaceStyle = computed(() => {
  const parsed = Number.parseFloat(props.height);
  const value = Number.isFinite(parsed) ? parsed : 2;
  const size = `${Math.abs(value)}rem`;

  return value >= 0 ? { height: size } : { marginBottom: `-${size}` };
});
</script>

<template>
  <div
    class="w-100p flex-shrink-0"
    :class="{ 'bg-white': whiteBackground }"
    :style="spaceStyle"
    aria-hidden="true"
  />
</template>
